module.exports = __webpack_public_path__ + "img/music-off.e16701c4.jpg";